import { renderingSalesChannelConfig } from './state';

export default (salesChannelID, environment) => ({
  state: renderingSalesChannelConfig(salesChannelID, environment),
  namespaced: true,
});
